import { useState, useEffect, useRef } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { FileSignature } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function SignatureModal({ anticipationId, signerToken, open, onOpenChange, onSigned }) {
  const iframeRef = useRef(null);
  const [signed, setSigned] = useState(false);

  const signerUrl = `https://app.zapsign.com.br/verificar/${signerToken}`;

  useEffect(() => {
    if (!open) return;
    const handler = async (e) => {
      if (e.data === "zs-doc-signed") {
        setSigned(true);
        try {
          await api.post(`/anticipations/${anticipationId}/mark-signed`);
          toast.success("Contrato assinado com sucesso!");
          onSigned?.();
        } catch { /* silent */ }
      }
      if (e.data === "zs-doc-loaded") {
        // Doc loaded
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [open, anticipationId, onSigned]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-3xl border-white/10 max-h-[90vh] p-0 overflow-hidden" data-testid="signature-modal">
        <DialogHeader className="p-4 pb-2">
          <DialogTitle className="flex items-center gap-2">
            <FileSignature className="w-5 h-5 text-blue-400" />
            {signed ? "Contrato Assinado!" : "Assinar Contrato"}
          </DialogTitle>
          <DialogDescription>
            {signed ? "Sua assinatura foi registrada." : "Revise e assine o contrato da operação de antecipação"}
          </DialogDescription>
        </DialogHeader>
        {!signed ? (
          <iframe
            ref={iframeRef}
            src={signerUrl}
            width="100%"
            height="600px"
            allow="camera"
            className="border-0"
            data-testid="zapsign-iframe"
          />
        ) : (
          <div className="flex flex-col items-center justify-center py-12">
            <div className="w-16 h-16 rounded-full bg-emerald-500/10 flex items-center justify-center mb-4">
              <FileSignature className="w-8 h-8 text-emerald-400" />
            </div>
            <p className="text-lg font-semibold text-emerald-400">Assinatura concluída</p>
            <p className="text-sm text-muted-foreground mt-1">O contrato será processado em breve</p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
